module.exports = __webpack_public_path__ + "static/media/subset-Roboto-Bold.456dcac8.woff2";